/* eslint-disable prefer-template */
'use strict';

var fragt = fragt || {};
fragt.contactButtons = fragt.contactButtons || new function () {

    this.init = function () {
        var contactButtons = document.querySelectorAll('[data-tel]');


        for (var i = 0; i < contactButtons.length; i++) {
            var contactButton = contactButtons[i];

            contactButton.addEventListener('click', function () {

                var tel = contactButton.getAttribute('data-tel');

                contactButton.innerHTML = tel;
                contactButton.setAttribute('href', 'tel:' + tel);

            });

        }
    };

}();
